import { createSlice } from '@reduxjs/toolkit';
// utils
import axios from '../../utils/axios';

// ----------------------------------------------------------------------

function objFromArray(array, key = 'id') {
  return array.reduce((accumulator, current) => {
    accumulator[current[key]] = current;
    return accumulator;
  }, {});
}

const initialState = {
  isLoading: false,
  // // sucursal actual
  actualSucursal: null,
  // aceptar item
  infoAceptarItemSucursal: {
    responsableActualId: '',
    responsableType: '',
    status: '',

    origenSucursalId: '',
    origenSucursalName: '',
    origenSucursalCalle: '',
    origenSucursalNumCalle: '',
    origenSucursalColonia: '',
    origenSucursalCiudad: '',
    origenSucursalEstado: '',
    origenSucursalCodPost: '',
    origenSucursalPlaceId: '',
    origenSucursalCoordinates: {},

    destinoSucursalId: '',
    destinoSucursalName: '',
    destinoSucursalCalle: '',
    destinoSucursalNumCalle: '',
    destinoSucursalColonia: '',
    destinoSucursalCiudad: '',
    destinoSucursalEstado: '',
    destinoSucursalCodPost: '',
    destinoSucursalPlaceId: '',
    destinoSucursalCoordinates: {},

    remitenteINE: '',
    remitenteNombre: '',
    remitenteApellidos: '',
    remitenteTelefono: '',
    remitenteEmail: '',

    destinatarioNombre: '',
    destinatarioApellidos: '',
    destinatarioTelefono: '',

    tipoServicio: '',
    descripcionContenido: '',
    observaciones: '',
    claveNip: ''
  },

  infoCrearPaletizado: {
    paletizadoCode: '',

    origenSucursalId: '',
    origenSucursalName: '',
    origenSucursalCalle: '',
    origenSucursalNumCalle: '',
    origenSucursalColonia: '',
    origenSucursalCiudad: '',
    origenSucursalEstado: '',
    origenSucursalCodPost: '',
    origenSucursalPlaceId: '',
    origenSucursalCoordinates: {},

    destinoSucursalId: '',
    destinoSucursalName: '',
    destinoSucursalCalle: '',
    destinoSucursalNumCalle: '',
    destinoSucursalColonia: '',
    destinoSucursalCiudad: '',
    destinoSucursalEstado: '',
    destinoSucursalCodPost: '',
    destinoSucursalPlaceId: '',
    destinoSucursalCoordinates: {},

    status: '',
    paletizadoItems: [],
    evidenciasPaletizado: [],

    responsableActualId: '',
    responsableType: ''
  },

  acceptedItemId: null
};

const slice = createSlice({
  name: 'dagpacketCrece',
  initialState,
  reducers: {
    // START LOADING
    startLoading(state) {
      state.isLoading = true;
    },

    // sucursal actual

    getActualSucursal(state, action) {
      const data = action.payload;

      state.actualSucursal = { ...data };
    },

    // aceptar nuevo item

    getSucursalOrigen(state, action) {
      const data = action.payload;
      state.infoAceptarItemSucursal = { ...state.infoAceptarItemSucursal, ...data };
    },

    getSucursalDestino(state, action) {
      const data = action.payload;
      state.infoAceptarItemSucursal = { ...state.infoAceptarItemSucursal, ...data };
    },

    getRemitInfo(state, action) {
      const data = action.payload;

      state.infoAceptarItemSucursal = { ...state.infoAceptarItemSucursal, ...data };
    },
    getDestinatarioInfo(state, action) {
      const data = action.payload;

      state.infoAceptarItemSucursal = { ...state.infoAceptarItemSucursal, ...data };
    },

    getTipoServicio(state, action) {
      const tipo = action.payload;

      state.infoAceptarItemSucursal.tipoServicio = tipo;
    },

    getExtraData(state, action) {
      const data = action.payload;

      state.infoAceptarItemSucursal = { ...state.infoAceptarItemSucursal, ...data };
    },

    getAcceptedItemId(state, action) {
      const id = action.payload;
      state.acceptedItemId = id;
    },

    resetInfoAcceptedItem(state) {
      state.infoAceptarItemSucursal = {
        origenSucursalId: '',
        origenSucursalName: '',
        origenSucursalCalle: '',
        origenSucursalNumCalle: '',
        origenSucursalColonia: '',
        origenSucursalCiudad: '',
        origenSucursalEstado: '',
        origenSucursalCodPost: '',
        origenSucursalPlaceId: '',
        origenSucursalCoordinates: {},

        destinoSucursalId: '',
        destinoSucursalName: '',
        destinoSucursalCalle: '',
        destinoSucursalNumCalle: '',
        destinoSucursalColonia: '',
        destinoSucursalCiudad: '',
        destinoSucursalEstado: '',
        destinoSucursalCodPost: '',
        destinoSucursalPlaceId: '',
        destinoSucursalCoordinates: {},

        remitenteINE: '',
        remitenteNombre: '',
        remitenteApellidos: '',
        remitenteTelefono: '',
        remitenteEmail: '',

        destinatarioNombre: '',
        destinatarioApellidos: '',
        destinatarioTelefono: '',

        tipoServicio: '',
        observaciones: '',
        claveNip: ''
      };
    },

    // crear paletizado

    getSucursalOrigenPaletizado(state, action) {
      const data = action.payload;
      state.infoCrearPaletizado = { ...state.infoCrearPaletizado, ...data };
    },

    getPaletizadoCode(state, action) {
      const data = action.payload;
      state.infoCrearPaletizado = { ...state.infoCrearPaletizado, ...data };
    },

    getSucursalDestinoPaletizado(state, action) {
      const data = action.payload;
      state.infoCrearPaletizado = { ...state.infoCrearPaletizado, ...data };
    },

    getItemsPaletizados(state, action) {
      const data = action.payload;

      const findedItem = state.infoCrearPaletizado.paletizadoItems.find((item) => item.id === data.id);

      if (findedItem) {
        state.infoCrearPaletizado.paletizadoItems = state.infoCrearPaletizado.paletizadoItems.filter(
          (item) => item.id !== data.id
        );
      } else {
        state.infoCrearPaletizado.paletizadoItems = [...state.infoCrearPaletizado.paletizadoItems, data];
      }
      // state.infoCrearPaletizado = { ...state.infoCrearPaletizado, ...data };
    },

    resetPaletizadoInfo(state) {
      state.infoCrearPaletizado = {
        paletizadoCode: '',

        origenSucursalId: '',
        origenSucursalName: '',
        origenSucursalCalle: '',
        origenSucursalNumCalle: '',
        origenSucursalColonia: '',
        origenSucursalCiudad: '',
        origenSucursalEstado: '',
        origenSucursalCodPost: '',
        origenSucursalPlaceId: '',
        origenSucursalCoordinates: {},

        destinoSucursalId: '',
        destinoSucursalName: '',
        destinoSucursalCalle: '',
        destinoSucursalNumCalle: '',
        destinoSucursalColonia: '',
        destinoSucursalCiudad: '',
        destinoSucursalEstado: '',
        destinoSucursalCodPost: '',
        destinoSucursalPlaceId: '',
        destinoSucursalCoordinates: {},

        status: '',
        paletizadoItems: []
      };
    }
  }
});

// Reducer
export default slice.reducer;

// Actions
export const {
  getSucursalOrigen,
  getSucursalDestino,
  getRemitInfo,
  getDestinatarioInfo,
  getTipoServicio,
  getExtraData,
  getActualSucursal,
  getAcceptedItemId,
  resetInfoAcceptedItem,

  getPaletizadoCode,
  getSucursalOrigenPaletizado,
  getSucursalDestinoPaletizado,
  getItemsPaletizados,
  resetPaletizadoInfo
} = slice.actions;

// ----------------------------------------------------------------------

// export function addEmpaqueUserCartAction(obj) {
//   return (dispatch) => {
//     // dispatch(addEmpaqueUserCart(obj));
//     // dispatch(setEmpaqTipoEnvio());
//   };
// }

// ----------------------------------------------------------------------
